import { orderBy, isDate } from 'lodash';

export function getCatCard(state) {
  return state.catCard || {};
}

export function getCatCardId(state) {
  return state.catCard.id;
}

export function getCatType(state, getters) {
  return getters.getCatCard.type || null;
}

export function isEvaluationCatType(state, getters) {
  return getters.getCatType === 'evaluation';
}

export function isRankCatType(state, getters) {
  return getters.getCatType === 'ranking';
}

export function isPreparationCatType(state, getters) {
  return getters.getCatType === 'preparation';
}

export function isCatCompleted(state, getters) {
  return (getters.getCatCard.remain_quiz_count || 0) === 0;
}

export function getOrderHistoryScores(state, getters) {
  const sortTargetName = 'updated_at';
  const limitScore = 4;

  const defaultScore = {
    proficiency_score: 0,
    updated_at: '',
  };

  if (getters.getHistoryScores.length === 0) {
    return [
      defaultScore,
    ];
  }

  if (getters.getHistoryScores.length === 1) {
    return [
      defaultScore,
      ...getters.getHistoryScores,
    ];
  }

  return orderBy([...getters.getHistoryScores.slice(0, limitScore)], sortTargetName, ['asc']);
}

export function getHistoryScoresData(state, getters) {
  return getters.getOrderHistoryScores.map(item => (
    (item.proficiency_score || 0)
  ));
}

export function getHistoryScoresDates(state, getters) {
  return getters.getOrderHistoryScores.map(item => (
    (item.updated_at || '')
  ));
}

export function getHistoryScoreDateLabels(state, getters) {
  return getters.getHistoryScoresDates.map((item) => {
    if (item === '') {
      return item;
    }

    const date = isDate(item) ? item : new Date(item.slice(0, 10));
    return `${(date.getMonth() + 1)}.${date.getDate()}`;
  });
}

export function getLastCatRanking(state) {
  if (state.catRanking.length === 0) return {};
  return state.catRanking[0];
}
